<template>
  <button>
    <slot />
  </button>
</template>

<style lang="scss" scoped>
button {
  border: none;
  color: #ffffff;
  transition: background 0.15s ease-in-out;
  cursor: pointer;

  &:disabled {
    pointer-events: none;
    opacity: 0.4;
  }

  &[data-size="sm"],
  & {
    --background: 5 5 5;
    background: rgb(var(--background) / 0.9);
    border-radius: 6px;
    font-size: 16px;
    padding: 8px 24px 9px;

    font-family: "Roboto Mono";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 140%;
    letter-spacing: -0.013em;

    &:hover {
      background: rgb(var(--background) / 0.8);
    }

    &:active {
      background: rgb(var(--background) / 1);
    }
  }

  &[data-size="big"] {
    font-family: "Graphik LCG";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 140%;
    /* or 25px */

    letter-spacing: -0.02em;
    text-transform: uppercase;
    --background: 5 5 5;
    background: rgb(var(--background) / 0.9);
    padding: 8px 24px 9px;
    border-radius: 12px;

    &:hover {
      background: rgb(var(--background) / 0.8);
    }

    &:active {
      background: rgb(var(--background) / 1);
    }
  }
}
</style>
